// src/App.jsx
import { Routes, Route } from "react-router-dom";
// import Home from "./pages/Home";
import ListingsList from "./pages/ListingsList";
import ListingDetail from "./pages/ListingDetail";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Search from "./pages/Search";
import Contact from "./pages/Contact";
import About from "./pages/About";

import './App.css'
function App() {
  return (
    <>
      <Header />

      <main>

        <Routes>
          <Route path="/" element={<ListingsList />} />
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/search" element={<Search />} />
          <Route path="/help" element={<div>Coming Soon</div>} />
          <Route path="/safety" element={<div>Coming Soon</div>} />
          <Route path="/contct" element={<div>Coming Soon</div>} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />

    </>
  );
}



export default App;